import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// PAR-15 — import de côté-effet, initialise i18next AVANT le premier rendu
// (aucun `I18nextProvider` nécessaire : `initReactI18next` enregistre une
// instance globale que `useTranslation()` consomme directement).
import './i18n';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
